import { render, staticRenderFns } from "./eventNotes.vue?vue&type=template&id=21f7eb3a&scoped=true"
import script from "./eventNotes.vue?vue&type=script&lang=js"
export * from "./eventNotes.vue?vue&type=script&lang=js"
import style0 from "./eventNotes.vue?vue&type=style&index=0&id=21f7eb3a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21f7eb3a",
  null
  
)

export default component.exports